import {
    AccessSegment,
    ColumnMetadata,
    ColumnTypes,
} from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { Emdash } from "~/components/Punctuation";
import { BadgeArrayCell } from "./BadgeArrayCell";
import { AssetTableRowData } from "../types";

// // // //

export const SECTORS_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> = {
    label: "Sectors",
    slug: "sectors",
    type: ColumnTypes.string,
    width: 190,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    // ENHANCEMENT - add sorting for sector_names
    // sortsOn: AssetColumns.sector_names,
    render: (item) => {
        if (item.isAsset) {
            const sectors = (item.sector_names || []) as string[];
            return <BadgeArrayCell values={sectors} />;
        }
        return <Emdash />;
    },
};
